import {
  VuexModule,
  Module,
  MutationAction,
  getModule,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { RequestsService } from "@/services/api/request.service";


import { DataTableOption } from "../../lib/DataTableOption.type";
import { AttachByCodeDTO, Attachment, Bank, DelReqDTO, OrgBranch, OrgType, Region, ReqDetail, ReqPlan, Requests, RequestsDTO, SaveFileByCodeNameDTO, SaveFileDTO, SavePlanDTO, SaveRequestDTO, SendReqDTO, SignedDTO } from "~/requests.type";

@Module({
  dynamic: true,
  store,
  name: "requests",
  preserveState: localStorage.getItem("vuex") !== null,
})
export class RequestsVuexModule extends VuexModule {

  SelectedItem: Requests = null as any;
  RefRegions: Region[] = [];
  BanksForRefs: Bank[] = [];
  OrgBranches: OrgBranch[] = [];
  OrgTypes: OrgType[] = [];
  RequestsList: Requests[] = [];
  listPagination: DataTableOption = new DataTableOption();
  loading: boolean = false;
  listLength: number = 0;
  attachmentList: Attachment[] = [];
  reqDetailList: ReqDetail[] = [];
  planList: ReqPlan[] = [];
  record_id: number = null as any;

  @Mutation
  public setSelectedItem(val: Requests) {
    this.SelectedItem = val;
  }

  @Mutation
  public setlistPagination(val: DataTableOption) {
    this.listPagination = val;
  }

  @MutationAction
  public async setloading() {
    const loading = true;
    return { loading };
  }

  @MutationAction
  public async loadRefRegions() {
    const RefRegions = await RequestsService.getRefRegions();
    return { RefRegions };
  }
  @MutationAction
  public async loadBanksForRefs() {
    const BanksForRefs = await RequestsService.getBanksForRefs();
    return { BanksForRefs };
  }
  @MutationAction
  public async loadOrgBranches() {
    const OrgBranches = await RequestsService.getOrgBranches();
    return { OrgBranches };
  }
  @MutationAction
  public async loadOrgTypes() {
    const OrgTypes = await RequestsService.getOrgTypes();
    return { OrgTypes };
  }
  @MutationAction
  public async loadRequestsList(req: RequestsDTO) {
    const RequestsList = await RequestsService.getRequestList(req);
    const loading = false;
    const listLength = RequestsList && RequestsList.length && RequestsList.length > 0 ? RequestsList[0].row_count : 0;
    return { RequestsList, loading, listLength };
  }
  @MutationAction
  public async getAttachments(CRRID: number) {
    const attachmentList = await RequestsService.getAttachments(CRRID);
    return { attachmentList };
  }
  @Action
  public async addEditReq(req: SaveRequestDTO) {
    return await RequestsService.addEditReq(req);
  }
  @MutationAction
  public async getContractorRequest(RID: number) {
    const reqDetailList = await RequestsService.getContractorRequest(RID);
    return { reqDetailList };
  }
  @MutationAction
  public async getRequestPlan(RID: number) {
    const planList = await RequestsService.getRequestPlan(RID);
    return { planList };
  }
  @Mutation
  public async setPlan(val: ReqPlan[]) {
    this.planList = val;
  }
  @Action
  public async addEditPlan(req: SavePlanDTO) {
    await RequestsService.addEditPlan(req);
  }
  @Action
  public async uploadFile(req: SaveFileDTO) {
    await RequestsService.uploadFile(req);
  }
  @Mutation
  public async setAttacList(val: Attachment[]) {
    this.attachmentList = val;
  }
  @Action
  public async getFile(attach_id: number) {
    return await RequestsService.getFile(attach_id);
  }
  @Action
  public async deleteAttachment(attach_id: number) {
    return await RequestsService.deleteAttachment(attach_id);
  }
  @Action
  public async sendReqToConsidering(req: SendReqDTO) {
    return await RequestsService.sendReqToConsidering(req);
  }
  @Action
  public async deleteRequest(req: DelReqDTO) {
    return await RequestsService.deleteRequest(req);
  }
  @Action
  public async getAttachmentByCodeName(req: AttachByCodeDTO) {
    return await RequestsService.getAttachmentByCodeName(req.CCRID, req.CodeName);
  }
  @Action
  public async uploadfileByCodeName(req: SaveFileByCodeNameDTO) {
    await RequestsService.uploadfileByCodeName(req);
  }
  @Action
  public async sendReqToSigned(req: SignedDTO) {
    return await RequestsService.sendReqToSigned(req);
  }
}

export const RequestsModule = getModule(RequestsVuexModule);
